import { InferType, number, object, string } from "yup";

const preAlertItemSchema = object({
    materialNumber: string()
        .when("$nssMaterialNumberRequired", {
            is: true,
            then: (s) => s.required(),
            otherwise: (s) => s.notRequired(),
        })
        .default(""),
    productId: number().required().min(1).default(undefined),
    productSku: string().required(),
    quantity: number().required().min(1).default(0),
    unitValue: number().notRequired().nullable().default(null),
    currencyCode: string().required().default("GBP"),
});

export const defaultPreAlert: PreAlertItem = {
    currencyCode: "GBP",
    materialNumber: "",
    productId: 0,
    productSku: "",
    quantity: 0,
    unitValue: 0,
};

export type PreAlertItem = InferType<typeof preAlertItemSchema>;

const preAlertItemIsValid = (preAlertItem: PreAlertItem, nssMaterialNumberRequired: boolean): boolean => {
    return preAlertItemSchema.isValidSync(preAlertItem, { context: { nssMaterialNumberRequired: nssMaterialNumberRequired } });
};

const materialNumberIsValid = (materialNumber: string, nssMaterialNumberRequired: boolean): boolean => {
    return preAlertItemSchema
        .pick(["materialNumber"])
        .isValidSync({ materialNumber: materialNumber }, { context: { nssMaterialNumberRequired: nssMaterialNumberRequired } });
};

const quantityIsValid = (quantity: number): boolean => {
    return preAlertItemSchema.pick(["quantity"]).isValidSync({ quantity: quantity });
};

const currencyCodeIsValid = (currencyCode: string): boolean => {
    return preAlertItemSchema.pick(["currencyCode"]).isValidSync({ currencyCode: currencyCode });
};

export const preAlertValidation = { currencyCodeIsValid, quantityIsValid, materialNumberIsValid, preAlertItemIsValid };
